module.exports = __webpack_public_path__ + "assets/img/search_none.471f27ae.png";